import { render, staticRenderFns } from "./ObjectifSection.vue?vue&type=template&id=180fc871&scoped=true&"
import script from "./ObjectifSection.vue?vue&type=script&lang=js&"
export * from "./ObjectifSection.vue?vue&type=script&lang=js&"
import style0 from "./ObjectifSection.vue?vue&type=style&index=0&id=180fc871&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180fc871",
  null
  
)

export default component.exports